
"use client";
import { useLocationContext } from "src/lib/contexts/ContextTypes";
import styles from "./MySelectedLocations.module.css";
import cn from "classnames";
import Button from "src/components/button/Button";
import CloseSvg from "src/components/svg/CloseSvg";

//#region [Props]
type MySelectedLocationsProps = {
    className?: string;
    children?: React.ReactNode;
};
//#endregion

//#region [Component]
export default function MySelectedLocations({ className, children }: MySelectedLocationsProps) {
    const { location } = useLocationContext();
    if ((location?.length ?? 0) === 0) {
        return children ?? null;
    }
    return (<div className={cn(styles.ButtonRow, className)}>
        <h5 className={styles.Heading}>Mine valgte steder:</h5>
        <MySelectedLocationsList className={className}>{children}</MySelectedLocationsList>
    </div>);
}
//#endregion

export function MySelectedLocationsList({ className, children }: MySelectedLocationsProps) {
    const { location, removeLocation } = useLocationContext();

    if ((location?.length ?? 0) === 0) {
        return children ?? null;
    }

    return <div className={cn("MySelectedLocations", styles.LocationList, className)}>
        {location!.map(loc => <Button
            key={loc}
            text={loc}
            borderStyle="square"
            className={styles.MyLocButton}
            onClick={() => removeLocation(loc)}
            icon={<CloseSvg className={styles.CloseIcon} />}
            dkVariant="dark"
        />)}
        {children}
    </div>
}